import { generateBlockId, defaultHeadingText } from './canvas-block-layouts/common'

export { generateBlockId }

const defaultHeadingStyle = {
  width: '1200px',
  height: '60px',
  transform: 'translate(30px, 20px)',
}
const defaultContentStyle = {
  width: '1200px',
  height: '450px',
  transform: 'translate(30px, 120px)',
}
const headingContent = (headingText) => {
  return {
    value: `
    <p style="text-align: left;" data-mce-style="text-align: left;">
      <span style="font-size: 48px;" data-mce-style="font-size: 48px;">
        <strong>
          ${headingText}
        </strong>
      </span>
    </p>
    `,
  }
}

const bodyContent = (bodyText) => {
  return {
    value: `
      <p style="text-align: left;" data-mce-style="text-align: left;">
        ${bodyText}
      </p>
    `,
  }
}

export function DefaultCanvasBlocks(slideId) {
  const newCanvasBlocks = {}
  newCanvasBlocks[generateBlockId(slideId)] = {
    type: 'RichText',
    tag: 'heading',
    content: headingContent(defaultHeadingText),
    style: defaultHeadingStyle,
  }
  newCanvasBlocks[generateBlockId(slideId)] = {
    type: 'RichText',
    tag: 'content',
    content: bodyContent('Click to add content'),
    style: defaultContentStyle,
  }
  return newCanvasBlocks
}
